import { RootState } from "../../redux-store";

export const selectOrg = (state: RootState) => state.org.org;
